import React, { useState } from 'react';
import Edit from './Edit';
import { db } from './Firebase';

const Update = ({ allItems }) => {
    const [edit, setEdit] = useState(null);
    document.title = 'SIHAH - Update';

    // delete items
    function deleteItems(id) {
        if(window.confirm("Are you sure?")) {
            db.collection("items").doc(id).delete()
            .then(() => console.log("Document successfully deleted!"));
        }
    }

    return (
        <section id="update" className="pt-3 pb-5 text-center container">
            <h1 className="mb-5 title"><b>Edit Products</b></h1>
            <div className="card-columns">
                {
                    allItems.map(item => 
                        <div className="card border-0 shadow" key={item.id}>                            
                            <img src={item.data.photo} alt={item.data.name} className="img-fluid card-image-top" />
                            {
                                edit === item.id ?
                                <Edit id={item.id} item={item.data} setEdit={setEdit} /> :
                                <>
                                <div className="card-body text-center">
                                    <h5><b>{item.data.name}</b></h5>
                                    <h6 className="text-secondary mb-4">Price: {item.data.price}/=</h6>
                                    <button onClick={() => setEdit(item.id)} className="btn btn-one text-white">Edit</button>
                                    <button onClick={() => deleteItems(item.id)} className="btn btn-danger ml-3">Delete</button>
                                </div>
                                </>
                            }                      
                        </div>
                    )
                }
            </div>
        </section>
    );
};

export default Update;